import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './AdminOrganizations.css';
import adminApiService from './AdminApiService';

const AdminOrganizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      // const token = localStorage.getItem('adminToken');
      // const response = await axios.get('http://localhost:5001/api/v1/admin/organizations', {
      //   headers: { Authorization: `Bearer ${token}` }
      // });
      const response = await adminApiService.getAllOrganiations()

      setOrganizations(response.organizations || []);
    } catch (error) {
      console.error('Error fetching organizations:', error);
      toast.error('Failed to load organizations');
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const token = localStorage.getItem('adminToken');
      await axios.patch(
        `http://localhost:5000/api/v1/admin/organizations/${id}`,
        { is_active: !currentStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Organization status updated');
      fetchOrganizations();
    } catch (error) {
      console.error('Error updating organization:', error);
      toast.error('Failed to update organization');
    }
  };

  const filteredOrganizations = organizations.filter(org => {
    const matchesFilter = filter === 'all' ||
      (filter === 'active' && org.is_active) ||
      (filter === 'inactive' && !org.is_active);
    const matchesSearch =
      org.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      org.industry?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      org.contact_email?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  if (loading) {
    return <div className="admin-organizations"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="admin-organizations">
      <div className="page-header">
        <h1>Organizations</h1>
        <div className="header-stats">
          <div className="stat-card">
            <span className="stat-label">Total</span>
            <span className="stat-value">{organizations.length}</span>
          </div>
          <div className="stat-card">
            <span className="stat-label">Active</span>
            <span className="stat-value">{organizations.filter(o => o.is_active).length}</span>
          </div>
          <div className="stat-card">
            <span className="stat-label">Inactive</span>
            <span className="stat-value">{organizations.filter(o => !o.is_active).length}</span>
          </div>
        </div>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by name, industry, or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-buttons">
          <button
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button
            className={filter === 'active' ? 'active' : ''}
            onClick={() => setFilter('active')}
          >
            Active
          </button>
          <button
            className={filter === 'inactive' ? 'active' : ''}
            onClick={() => setFilter('inactive')}
          >
            Inactive
          </button>
        </div>
      </div>

      <div className="table-container">
        <table className="organizations-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Industry</th>
              <th>Contact Email</th>
              <th>Contact Phone</th>
              <th>Website</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrganizations.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">No organizations found</td>
              </tr>
            ) : (
              filteredOrganizations.map(org => (
                <tr key={org.id}>
                  <td>
                    <div className="org-name">
                      {org.logo_url && (
                        <img src={org.logo_url} alt={org.name} className="org-logo" />
                      )}
                      <strong>{org.name}</strong>
                    </div>
                  </td>
                  <td>{org.industry || 'N/A'}</td>
                  <td>{org.contact_email || 'N/A'}</td>
                  <td>{org.contact_phone || 'N/A'}</td>
                  <td>
                    {org.website ? (
                      <a href={org.website} target="_blank" rel="noopener noreferrer">
                        Visit
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    <span className={`status-badge ${org.is_active ? 'badge-success' : 'badge-danger'}`}>
                      {org.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{new Date(org.created_at).toLocaleDateString()}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className={org.is_active ? 'btn-deactivate' : 'btn-activate'}
                        onClick={() => toggleStatus(org.id, org.is_active)}
                      >
                        {org.is_active ? 'Deactivate' : 'Activate'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminOrganizations;


